import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import {
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { getVendorMasterDataAPI } from "../../../../services/inventory/vendorService";
import MapPlaces from "../../../../partials/content/MapPlaces";
import DialogLayout from "../../../../partials/content/DialogLayout";
function IncomingInvoiceAddress({
  values,
  vendorAddresses = [],
  title,
  setFieldValue,
  vendorAddressDefault = false,
  handleVendorAddressDefault,
}) {
  const [addressOptions, setAddressOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  useEffect(() => {
    function getVendorMasterData() {
      getVendorMasterDataAPI().then((response) => {
        const { data, auth } = response.data;
        const { countries } = data;
        setAddressData(vendorAddresses, countries);
      });
    }
    getVendorMasterData();
  }, [vendorAddresses]);
  return (
    <React.Fragment>
      <Card>
        <Card.Header>
          <i className="fas fa-map-marked-alt"></i>
          <span>
            <strong>{title} Address</strong>
          </span>
        </Card.Header>
        <Card.Body>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <FormSelectField
                label="Address Name Reference"
                name="addressName"
                options={addressOptions}
                onSelectChange={(addressValue) => {
                  setFieldValue("addressName", addressValue);
                  setFieldValue("address", addressValue.address);
                  setFieldValue("city", addressValue.city);
                  setFieldValue("province", addressValue.province);
                  setFieldValue("countryCode", addressValue.countryCode);
                  setFieldValue("postalCode", addressValue.postalCode);
                  setFieldValue("addressPhone", addressValue.addressPhone);
                  setFieldValue("addressEmail", addressValue.addressEmail);
                }}
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField
                label="Address"
                name="address"
                mapsButton
                onMapsClick={() => {
                  setOpenSearchMapPlaces(true);
                }}
              />
              <FormTextField label="City" name="city" />
              <FormTextField label="Province / State" name="province" />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField label="Phone Number" name="addressPhone" />
              <FormTextField label="Email" name="addressEmail" />
              <FormTextField label="Postal Code" name="postalCode" />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12">
              <FormSelectField
                label="Country"
                name="countryCode"
                options={countryOptions}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
      <DialogLayout
        open={openSearchMapPlaces}
        title="Search Address on Maps"
        onCloseDialog={() => {
          setOpenSearchMapPlaces(false);
        }}
        maxWIdth="lg"
        minHeight={true}
      >
        <MapPlaces
          address={values.address}
          city={values.city}
          province={values.province}
          countryCode={values.countryCode}
          postalCode={values.postalCode}
          onPinLocation={(
            selectedFormattedAddress,
            selectedShortAddressComponents,
            selectedLongAddressComponents,
            selectedAddress,
            selectedCity,
            selectedProvince,
            selectedCountryCode,
            selectedPostalCode
          ) => {
            setFieldValue(`address`, selectedAddress);
            setFieldValue(`city`, selectedCity);
            setFieldValue(`province`, selectedProvince);
            setFieldValue(`countryCode`, selectedCountryCode);
            setFieldValue(`postalCode`, selectedPostalCode);
            setOpenSearchMapPlaces(false);
          }}
          onCloseDialog={() => {
            setOpenSearchMapPlaces(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
  function setAddressData(vendorAddresses = [], countries = []) {
    let addressOptionsTmp = [];
    let countryOptionsTmp = [];
    addressOptionsTmp.push({
      value: {
        addressName: {},
        address: "",
        city: "",
        province: "",
        countryCode: "",
        postalCode: "",
        addressPhone: "",
        addressEmail: "",
      },
      label: "No Reference",
    });
    if (typeof countries !== "undefined") {
      countries.forEach((country) => {
        countryOptionsTmp.push({
          value: country.countryCode,
          label: country.countryName,
        });
      });
    }
    if (typeof vendorAddresses !== "undefined") {
      vendorAddresses.map((vendorAddress, index) => {
        addressOptionsTmp.push({
          value: vendorAddress,
          label: vendorAddress.addressName,
        });
        if (
          vendorAddress.addressName === "Main Address" &&
          vendorAddressDefault === true &&
          values.ID === 0
        ) {
          setFieldValue("addressName", vendorAddress);
          setFieldValue("address", vendorAddress.address);
          setFieldValue("city", vendorAddress.city);
          setFieldValue("province", vendorAddress.province);
          setFieldValue("countryCode", vendorAddress.countryCode);
          setFieldValue("postalCode", vendorAddress.postalCode);
          setFieldValue("addressPhone", vendorAddress.addressPhone);
          setFieldValue("addressEmail", vendorAddress.addressEmail);
          handleVendorAddressDefault();
        }
      });
    }
    setAddressOptions(addressOptionsTmp);
    setCountryOptions(countryOptionsTmp);
  }
}

export default IncomingInvoiceAddress;
